// extracted by mini-css-extract-plugin
export default {"menuContainer":"menu_menuContainer__4-Kbf","menuItems":"menu_menuItems__MMWKi","menuItem":"menu_menuItem__PM6Nr"};